import { mapQueryToPaginationProps, usePagination } from '@fourthwall/components'
import type { PayoutApiClient } from '@fourthwall/services/dist/PayoutApiClient'

import type { PayoutsHistoryDataItem, TransactionStatus } from '../Billing.types'
import { usePayoutTransactionsQuery } from '../queries/usePayoutTransactionsQuery'
import { getPaidTo } from '../utils/getPaidTo'

export type TransactionStatusData = Awaited<
  ReturnType<typeof PayoutApiClient.getPayoutTransactions>
>['data']['transactions'][number]['status']

export const PAYOUT_STATUS: Record<TransactionStatusData, TransactionStatus> = {
  PENDING: 'PROCESSING',
  IN_PROGRESS: 'PROCESSING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  REVERTED: 'REVERTED',
}

export type UsePayoutsHistoryProps = {
  enabled?: boolean
}

export const usePayoutsHistory = ({ enabled = false }: UsePayoutsHistoryProps) => {
  const [currentPage, setCurrentPage] = usePagination()
  const { payoutTransactionsQuery } = usePayoutTransactionsQuery(
    [
      {
        page: currentPage - 1,
        size: 10,
      },
    ],
    {
      enabled,
      keepPreviousData: true,
    },
  )

  const data: PayoutsHistoryDataItem[] =
    payoutTransactionsQuery.data?.transactions.map(
      ({ createdAt, transferAmount, payoutAmount, paidTo, status }) => ({
        date: createdAt,
        transferAmount,
        payoutAmount,
        paidTo: getPaidTo(paidTo),
        status: PAYOUT_STATUS[status],
      }),
    ) || []

  const pagination = mapQueryToPaginationProps(payoutTransactionsQuery, currentPage, setCurrentPage)

  return {
    data,
    isLoading: payoutTransactionsQuery.isLoading,
    pagination,
  }
}
